export default __webpack_public_path__ + "icon-action-menu.4352f403.png";